import { Outlet } from "react-router-dom";
import classNames from "classnames/bind";
import styles from "./Content.module.scss";

const cx = classNames.bind(styles);

export default function Content() {
  return (
    <main className={cx("main-content")}>
      <Outlet />
    </main>
  );
}

